<template>
  <v-dialog :model-value="modelValue" max-width="1400" scrollable @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon class="mr-2">mdi-graph-outline</v-icon>
        <span>Граф связей: {{ title ? `${title} (@${(username || '').replace(/^@/, '')})` : '@' + (username || '').replace(/^@/, '') }}</span>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" @click="$emit('update:modelValue', false)" />
      </v-card-title>
      <v-card-text class="pa-0">
        <ChannelGraph v-if="modelValue" :source-id="sourceId" :username="username" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ChannelGraph from '@/components/ChannelGraph.vue';

export default {
  name: 'ChannelGraphModal',
  components: { ChannelGraph },
  props: {
    modelValue: { type: Boolean, default: false },
    sourceId: { type: [Number, String], default: null },
    username: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
};
</script>
